import React from "react";
import { LoadDefSourceContainer } from "../../../containers";
const LoadDefinitionSource = (props) => {
  return <LoadDefSourceContainer {...props} />;
};

export default LoadDefinitionSource;
